import SignUpBloggerForm from './SignUpBloggerForm';

export default SignUpBloggerForm;
